import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';

const defaultPopperProps = {
  disablePortal: true,
  modifiers: [
    {
      name: 'preventOverflow',
      options: {
        boundary: 'clippingParents',
      },
    },
  ],
};

export const Tooltip = ({
  PopperProps = defaultPopperProps,
  ...props
}: TooltipProps) => <MuiTooltip PopperProps={PopperProps} {...props} />;
